import { useContext } from 'react'
import logo2 from '../../assets/logo2.png'
import logo3 from '../../assets/logo3.png'
import logoCaixaMagica from '../../assets/caixa-magica.png'
import strings from '../../res/strings'
import privacyFile from './privacy.pdf'
import { UserContext } from '../../App'

const Footer = () => {
    const { loggedUser } = useContext(UserContext)

    const year = new Date().getFullYear()

    const downloadFile = () => {
        const link = document.createElement('a')
        link.href = privacyFile
        link.setAttribute('download', 'Política de Privacidade Docapesca - Alagem Digital.pdf');
        document.body.appendChild(link)
        link.click()
    }

    return (
        <footer 
            className='hidden lg:relative lg:bottom-0 lg:left-0 lg:right-0 lg:py-4 lg:flex lg:flex-row lg:items-center lg:justify-between lg:border-t lg:border-accent'
            style={{ paddingInline: loggedUser !== null ? 200 : 30 }}
        >
            
            <div className='flex flex-row space-x-[2.625rem] items-center'>
                <img className='h-[1.75rem] w-[9.25rem]' src={logo2} alt='Logo Docapesca'/>
                <img className='h-[2.588rem] w-[6.75rem]' src={logo3} alt='Logo República Portuguesa'/>
                
            </div>
            
            <div className='flex flex-row space-x-1'>
                <p onClick={downloadFile} className='text-base text-navy underline cursor-pointer'>{strings.privacy}</p>
                <p className='text-base text-neutral5'>|</p>
                <p className='text-base text-neutral5'>{`© ${year} · Docapesca`}</p>
            </div>
            
        </footer>
    )
}

export default Footer